import React, { Component } from "react";
import Magnific from './magnific.jsx';
import { postSendWishlistCSVEmail } from '../../apis/wishlist';
import toast from '../../components/toast';

class WishlistCSVModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            email: '',
            message: '',
            show: false,
            isSending: false,
            errors: []
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.openBtn = React.createRef();
    }

    handleClick() {
        this.setState({
            show: true
        });
    }

    handleClose() {
        this.setState({
            show: false
        },
            () => {
                this.openBtn.current.focus();
            });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        if (!this.state.isSending) {
            this.setState({
                isSending: true,
                errors: []
            });

            postSendWishlistCSVEmail({
                wishlistId: this.props.id,
                name: this.state.name,
                email: this.state.email,
                message: this.state.message
            })
                .then(json => {
                    this.setState({
                        isSending: false
                    });

                    if (json.success) {
                        this.setState({
                            name: '',
                            email: '',
                            message: '',
                            show: false
                        });
                        toast.success('Your email will be sent shortly');
                    }
                    else {
                        this.setState({
                            errors: json.errors
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                    this.setState({
                        isSending: false
                    });
                    toast.error('There was an issue sending your email. Please try again soon.');
                });
        }
    }

    handleChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    render() {
        let errors;
        const activator = <button className="btn btn-icon-left btn-email-bg btn-block" type="button" ref={this.openBtn} onClick={this.handleClick}><span>Share via Email</span></button>;

        if (this.state.errors.length) {
            errors = <ul className="error-list">
                {this.state.errors.map((error) => (
                    <li>{error}</li>
                ))}
            </ul>;
        }

        return (
            <Magnific activator={activator} type="inline" show={this.state.show} onClose={this.handleClose}>
                <div className="card padded rounded">
                    <div className="card-title-content">
                        <h3 className="heading">Email your Wist List</h3>
                    </div>
                    <div className="card-text-content">
                        <p class="add-margin-btm">Send your wish list to someone.</p>
                        <form action="#" method="post" onSubmit={this.handleFormSubmit}>
                            {errors}

                            <div className="form-group">
                                <label htmlFor="name">Your Name *</label>
                                <input className="form-control" type="text" id="name" name="name" placeholder="John Doe" required value={this.state.name} onChange={this.handleChange}/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="email">To Email *</label>
                                <input className="form-control" type="email" id="email" name="email" placeholder="hello@vollrath.com" required value={this.state.email} onChange={this.handleChange}/>
                            </div>

                            <div className="form-group">
                                <label htmlFor="message">Message</label>
                                <textarea className="form-control" id="message" name="message" placeholder="Take a look at my wishlist!" rows="3" value={this.state.question} onChange={this.handleChange}></textarea>
                            </div>

                            <div className="form-actions">
                                <button className="btn" disabled={this.state.isSending}>Send</button>
                            </div>
                        </form>
                    </div>
                </div>
            </Magnific>
        );
    }
}

export default WishlistCSVModal;